module.exports = __webpack_public_path__ + "static/img/interturis-3.50db1fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/interturis-3.jpg
// module id = ELpy
// module chunks = 1